namespace RecordShield.Workspace {
    export interface AnalyticsRow {
        Id?: number;
        AnalyticsId?: number;
        ActivationLogId?: number;
        ActivationId?: number;
        UserId?: number;
        ProductId?: number;
        ProductItemId?: number;
        ContentKey?: number;
        StartedAt?: string;
        EndedAt?: string;
        WatchDurationInSeconds?: number;
        Sync?: boolean;
        SyncDate?: string;
        DeviceType?: string;
        DeviceId?: string;
        TenantId?: number;
        ProductName?: string;
        Subscriber?: string;
    }

    export namespace AnalyticsRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Workspace.Analytics';

        export namespace Fields {
            export declare const Id: string;
            export declare const AnalyticsId: string;
            export declare const ActivationLogId: string;
            export declare const ActivationId: string;
            export declare const UserId: string;
            export declare const ProductId: string;
            export declare const ProductItemId: string;
            export declare const ContentKey: string;
            export declare const StartedAt: string;
            export declare const EndedAt: string;
            export declare const WatchDurationInSeconds: string;
            export declare const Sync: string;
            export declare const SyncDate: string;
            export declare const DeviceType: string;
            export declare const DeviceId: string;
            export declare const TenantId: string;
            export declare const ProductName: string;
            export declare const Subscriber: string;
        }

        ['Id', 'AnalyticsId', 'ActivationLogId', 'ActivationId', 'UserId', 'ProductId', 'ProductItemId', 'ContentKey', 'StartedAt', 'EndedAt', 'WatchDurationInSeconds', 'Sync', 'SyncDate', 'DeviceType', 'DeviceId', 'TenantId', 'ProductName', 'Subscriber'].forEach(x => (<any>Fields)[x] = x);
    }
}
